import { schema } from 'normalizr'
import * as R from 'ramda'

// Anytime we are processing a district, give the district an
// additional property 'flyers', and set it equal to an array
// including the contents of parent.flyers ('school' is the
// parent in the data we receive from our
// districts/:districtId/flyers api).
const districtProcessStrategy = (value, parent, key) => {
  switch (key) {
    case 'district': {
      return {
        ...value,
        flyers: [...(parent.flyers || [])],
        schools: parent.school_id ? [parent.school_id] : []
      }
    }
    default: {
      return value
    }
  }
}

// With the default merge strategy, each district would have only
// the flyers of the final school processed, because we would
// overwrite the flyers property each time we create a district.
// This new merge strategy will merge the district's existing
// flyers array with that of the return value from the district
// process strategy.
const districtMergeStrategy = (entityA, entityB) => ({
  ...entityA,
  ...entityB,
  flyers: R.uniq([...(entityA.flyers || []), ...(entityB.flyers || [])]),
  schools: R.uniq([...(entityA.schools || []), ...(entityB.schools || [])])
})

// In districts/:districtId/flyers, 'flyer' is the parent object to school
// In districts/:districtId/schools, district could be the parent. As such,
// we check that the parent object is the 'flyer' object, and when
// that is the case, we add a 'flyers' property to the school and
// set it equal to an array with just this flyer id inside. When
// the parent object is a district, we just return the school as is.
const schoolProcessStrategy = (value, parent, key) => {
  if (parent.flyer_id) {
    return { ...value, flyers: [parent.flyer_id] }
  } else if (key === 'districts') {
    return { ...value, district: parent.district_id }
  }
  return { ...value, district: value.district_id }
}

// With the default merge strategy, each school would have an
// array of only the flyer id of the final flyer processed,
// because we would overwrite the 'parents' property each time we
// create a 'parent'. (mergeStrategy defaults to use the newest data)
// This new merge strategy will merge the school's existing
// 'flyers' array with that of the return value from the school
// process strategy.
const schoolMergeStrategy = (entityA, entityB) => ({
  ...entityA,
  ...entityB,
  flyers: [...(entityA.flyers || []), ...(entityB.flyers || [])]
})

export const districtSchema = new schema.Entity(
  'districts',
  {},
  {
    idAttribute: 'district_id',
    processStrategy: districtProcessStrategy,
    mergeStrategy: districtMergeStrategy
  }
)
export const schoolSchema = new schema.Entity(
  'schools',
  {},
  {
    idAttribute: 'school_id',
    processStrategy: schoolProcessStrategy,
    mergeStrategy: schoolMergeStrategy
  }
)
const flyerSchema = new schema.Entity(
  'flyers',
  {},
  {
    idAttribute: 'flyer_id'
  }
)

// A district has many schools and many flyers
districtSchema.define({
  schools: [schoolSchema],
  flyers: [flyerSchema]
})

// A school has one district and many flyers
schoolSchema.define({
  district: districtSchema,
  flyers: [flyerSchema]
})

flyerSchema.define({
  district: districtSchema,
  schools: [schoolSchema]
})

export const flyerListSchema = [flyerSchema]
export const schoolListSchema = [schoolSchema]



// WEBPACK FOOTER //
// ./src/shared/redux/schemas.js